<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQEsperienze',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Esperienze Adrenaliniche", link : 'conv-bitq-exp' } ],

        // Nome welfarebit del servizio
        service_title : "Esperienze Adrenaliniche",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 113
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>